import { Box, Flex, FormControl, FormLabel } from '@chakra-ui/react'
import { ResponsiveFormControlProps } from './interface'
import TextRequired from '../TextRequired'

const ResponsiveFormControl: React.FC<ResponsiveFormControlProps> = ({
  label,
  htmlFor,
  children,
  isRequired,
  labelWidth = '200px',
  messageComponents,
  ...props
}) => {
  return (
    <FormControl {...props}>
      <Flex>
        <FormLabel
          htmlFor={htmlFor}
          w={labelWidth}
          mb={{ base: '10px', lg: 0 }}
          mr="0"
          fontSize="14px"
          mt='2px'
        >
          {label}
          {isRequired && <TextRequired>*</TextRequired>}
        </FormLabel>
        <Box flex={1}>{children}</Box>
      </Flex>
      {messageComponents && <Box ml={labelWidth}>{messageComponents}</Box>}
    </FormControl>
  )
}

export default ResponsiveFormControl
